import AppletSubgroups from '../../../models/applet/applet-subgroup.entity';
import { StepsInterface } from '../interfaces/steps.interface';
import carContent from './car-steps.content';

class InspectionContentService {
  public getAtualAppletContent(applet: AppletSubgroups) {
    const atualContent: StepsInterface = carContent
      .find((item) => item.type === applet.type) || {} as StepsInterface;
    return atualContent || {};
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InspectionContentService();
